t = require('views/internal/teacup-with-helpers')('list')

module.exports = t.renderable ({ name, subscribed, loggedIn, distinctLists }) ->

  t.div '.list.js-list-content', { class: t.classify('distinct-list': distinctLists) }, ->

    headerClasses =
      'list-header': true
      'js-list-header': true
      'u-clearfix': true
      'is-menu-shown': loggedIn
      'is-subscribe-shown': subscribed

    t.div { class: t.classify(headerClasses) }, ->

      inputClasses =
        'list-header-name': true
        'mod-list-name': true
        'js-list-name-input': true

      t.div '.list-header-target.js-editing-target'

      t.h2 '.list-header-name-assist.js-list-name-assist', { dir: 'auto' }, name

      t.textarea { class: t.classify(inputClasses), 'aria-label': name, spellcheck: 'false', dir: 'auto', maxLength: 512 }, name

      t.p '.list-header-num-cards.hide.js-num-cards'

      t.div '.list-header-extras', ->

        subscribeClasses =
          'list-header-extras-subscribe': true
          'js-list-subscribed': true

        if !subscribed
          subscribeClasses['hide'] = true

        t.span { class: t.classify(subscribeClasses) }, ->
          t.icon 'subscribe'

        if loggedIn
          t.a '.list-header-extras-menu.dark-hover.js-open-list-menu', {
            href: '#'
            class: t.classify {
              'icon-lg icon-overflow-menu-horizontal': distinctLists
            }
          }, ->
            if !distinctLists
              t.icon 'overflow-menu-horizontal'
            else
              t.div()

    t.a '.open-card-composer.js-open-card-composer', { href: '#' }, ->
      if distinctLists
        t.icon 'add'
        t.span '.js-add-a-card', ->
          t.format 'add-a-card'
        t.span '.js-add-another-card.hide', ->
          t.format 'add-another-card'
      else
        t.format 'add-a-card-ellipsis'



// WEBPACK FOOTER //
// ./app/scripts/views/templates/list.coffee